module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "tx2",
    staticStyle: {
      "margin-top": "20%"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Hell and Beyond")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("“Michael Phillips skillfully immerses our imaginations in a detailed participation in what may be involved in ‘life after death.’ He neither defines nor explains. Instead, using fantasy as his genre, he takes us on an end run around the usual polarizing clichés regarding heaven and hell and enlists us in honest, prayerful biblical meditation. I highly recommend "), _c('i', [_vm._v("Hell and Beyond")]), _vm._v(" to anyone expecting to die, whether sooner or later.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("—Eugene Peterson")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Professor of Spiritual Theology")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Regent College, Vancouver, B.C.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("“Michael Phillips has done the impossible—written a thriller on "), _c('i', [_vm._v("hell.")]), _vm._v(" "), _c('i', [_vm._v("Hell and Beyond")]), _vm._v(" breathes the rarified air of George MacDonald’s "), _c('i', [_vm._v("Unspoken Sermons")]), _vm._v(" and "), _c('i', [_vm._v("Lilith,")]), _vm._v(" C. S. Lewis’ "), _c('i', [_vm._v("Till We Have Faces")]), _vm._v(" and "), _c('i', [_vm._v("The Great Divorce,")]), _vm._v(" and Paul Young’s "), _c('i', [_vm._v("The Shack")]), _vm._v(" and "), _c('i', [_vm._v("Cross Roads.")]), _vm._v(" If you are ready, this book can bring hope to places long buried in your tears. It is brilliant and scary, fantastic and unnerving, evangelistic and terrifying—every word drenched in undiluted love. You will find yourself longing to be healed to the roots of your soul by Jesus’ Father.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("—C. Baxter Kruger, Ph.D.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Author of "), _c('i', [_vm._v("Across All Worlds")]), _vm._v(" and "), _c('i', [_vm._v("The Shack Revisited")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-597fb19c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hell_and_Beyond_Split4.vue
// module id = 66
// module chunks = 0